import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import Checkbox from '../../form/Checkbox'
import Button from '../../../UniformComponents/Button'
import Typography from '../../../UniformComponents/Typography'
import Select from '../../form/Select'

import './emailBuilder.scss'

@observer
class EmailListModal extends Component {
    render() {
        const { distributeStore } = this.props

        return (
            <Modal
                show={distributeStore.emailListModalVisible}
                onClose={distributeStore.closeEmailListModal}
            >
                <h2>{i18n.t('distributionEmailList.upload')}</h2>

                <br />

                <Typography type="tiny">
                    <span dangerouslySetInnerHTML={{ __html: i18n.t('sch_upload_verification_msg') }} />
                </Typography>

                <br />

                <Typography type="tiny">
                    <span dangerouslySetInnerHTML={{ __html: i18n.t('sch_upload_verification_msg2') }} />
                </Typography>

                <br />

                <Select
                    label={i18n.t('sch_upload_delimiter')}
                    options={[
                        {
                            value: 'comma',
                            label: ',',
                        },
                        {
                            value: 'semicolon',
                            label: ';',
                        },
                        {
                            value: 'tab',
                            label: i18n.t('report_delimiter_tab'),
                        },
                    ]}
                    defaultValue={distributeStore.uploadDelimiter}
                    onBlur={({ value }) => { distributeStore.uploadDelimiter = value }}
                />

                <br />

                <div
                    className="kiosk-settings-modal-checkbox-option"
                    onClick={distributeStore.toggleConfirmationChecked}
                >
                    <Typography type="b">{i18n.t('sch_upload_verification_ch')}</Typography>

                    <Checkbox
                        checked={distributeStore.confirmationChecked}
                    />
                </div>

                <br />

                <hr />

                <br />

                <div className="create-user-modal-buttons">
                    <Button
                        cssClass="regular tertiary"
                        onClick={distributeStore.closeEmailListModal}
                        label={i18n.t('cancel')}
                    />

                    <Button
                        cssClass="regular primary"
                        onClick={distributeStore.verify}
                        label={i18n.t('gen_confirm_popup_title')}
                    />
                </div>
            </Modal>
        )
    }
}

export default EmailListModal
